module.exports = __webpack_public_path__ + "static/media/icon-egg-red.3c549332.jpg";